import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth, useLang } from "@/context/AppContext";
import { Logo } from "@/components/Logo";
import { LangSwitch } from "@/components/LangSwitch";
import { Input } from "@/components/ui/input";

export default function AuthPage({ mode }) {
  const { t } = useLang();
  const { setUser } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const isLogin = mode === "login";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const body = isLogin ? { email: f.email, password: f.password } : f;
      const { data } = await api.post(`/auth/${mode}`, body);
      setUser(data);
      nav("/app");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative grid min-h-screen place-items-center bg-[#0B0F17] px-4 grid-lines">
      <div className="absolute left-6 top-6 flex w-[calc(100%-3rem)] items-center justify-between">
        <Link to="/" data-testid="auth-back-home"><Logo /></Link>
        <LangSwitch />
      </div>
      <form onSubmit={submit} className="rise w-full max-w-md space-y-5 rounded-md border border-white/[0.08] bg-[#111827] p-8" data-testid={`${mode}-form`}>
        <h1 className="font-display text-3xl font-bold text-white">{t(isLogin ? "login_title" : "register_title")}</h1>
        <p className="font-mono text-[11px] uppercase tracking-widest text-yellow-300">{t("rule")}</p>
        {!isLogin && <Input required placeholder={t("name")} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="auth-name-input" />}
        <Input required type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="auth-email-input" />
        <Input required type="password" minLength={6} placeholder={t("pwd_label")} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="auth-password-input" />
        {error && <p className="text-sm text-rose-400" data-testid="auth-error">{error}</p>}
        <button disabled={busy} data-testid="auth-submit-btn" className="w-full rounded-full bg-emerald-500 py-3 text-sm font-semibold text-slate-950 transition-opacity duration-200 hover:opacity-90 disabled:opacity-50">
          {busy ? "…" : t(isLogin ? "login_btn" : "register_btn")}
        </button>
        <p className="text-center text-sm text-slate-400">
          {t(isLogin ? "no_account" : "have_account")}{" "}
          <Link to={isLogin ? "/register" : "/login"} className="text-emerald-300 hover:underline" data-testid="auth-switch-link">
            {t(isLogin ? "register_btn" : "login_btn")}
          </Link>
        </p>
      </form>
    </div>
  );
}
